<template>
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.75 9.27338V5.71338C0.75 1.29338 3.88 -0.516621 7.71 1.69338L10.8 3.47338L13.89 5.25338C17.72 7.46338 17.72 11.0834 13.89 13.2934L10.8 15.0734L7.71 16.8534C3.88 19.0634 0.75 17.2534 0.75 12.8334V9.27338Z"
            stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

</template>
